/**
 * Mask string rendered in place of confidential data-field values when the
 * viewer lacks can_view_confidential_info. Matches legacy behaviour where the
 * Angular template rendered 'XXXX' with a "This is confidential data" tooltip.
 *
 * Single source of truth — import from here instead of hardcoding in each component.
 */
export const CONFIDENTIAL_MASK = 'XXXX'
